import { createIcon } from '../createIcon.tsx';

export const MinusIcon = createIcon('MinusIcon', <line x1="5" y1="12" x2="19" y2="12" />);
